import { List, ListItemButton, ListItemIcon, ListItemText, styled } from "@mui/material";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
// import TrueFalse from 'components/simple/TrueFalse';
import { useNavigate } from "react-router-dom";

import "../../assets/styles/components/trueFalse.scss";
import { ExpandSwitch } from "components/Input/switch";

import TableSelectPerson from "components/Input/TableSelectPerson";
import TableSelectInvoice from "components/Input/TableSelectInvoice";
import TableSelectUser from "../Input/TableSelectUser";

export const PageHeader = ({ tab }: { tab: ReportsHeaderType }) => {
  return (
    <div className="header-right">
      <div className="product">{tab.title}</div>
      <div className="show-product">{tab.description}</div>
    </div>
  );
};

export const HeaderActions = ({ backComment, backLink }: { backComment?: string; backLink?: string }) => {
  const navigate = useNavigate();
  return (
    // <div className={"header-left"}>
    <a
      onClick={() => backLink ? navigate(backLink) : navigate(-1)}
      style={{
        color: "#A5A5A6",
        textDecoration: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        flexDirection: "row-reverse",
        gap: 12
      }}
      className="left-title-product"
    >
      {backComment || "بازگشت"}
      &nbsp;
      <ArrowBackIcon />
    </a>
    // </div>
  );
};

const ReportActionsContainer = styled("div")(({ theme }) => ({
  height: "34px",
  display: "flex",
  //   marginBottom: "50px",
  justifyContent: "space-between"
}));
const RightSection = styled("div")(({ theme }) => ({
  // width: "400px",
  display: "flex",
  justifyContent: "space-between"
}));

export const ReportActions = ({
                                openAll = true,
                                selectPerson,
                                personRefetch,
                                productRefetch,
                                userRefetch
                              }: {
  openAll?: boolean;
  selectPerson?: boolean;
  personRefetch?: (paginationState: any, token: any, personId: any) => void;
  productRefetch?: (paginationState: any, token: any, productId: any) => void;
  userRefetch?: (paginationState: any, token: any, userId: any) => void;
}) => {
  const input = {
    label: ""
  };
  return (
    <ReportActionsContainer>
      <RightSection>
        {openAll && <ExpandSwitch />}
        {/* @ts-ignore */}
        {selectPerson && <TableSelectPerson refetch={personRefetch} />}
        {/* @ts-ignore */}
        {productRefetch && <TableSelectInvoice refetch={productRefetch} />}
        {userRefetch && <TableSelectUser refetch={userRefetch} />}
      </RightSection>
      {/* TODO: needs to be uncommented! */}
      {/* <LeftSection>
                <StyledIconButton variant='disabled'>
                    <ExcelIcon />
                </StyledIconButton>
                <StyledIconButton variant='primary'>
                    <PrinterIcon />
                </StyledIconButton>
            </LeftSection> */}
    </ReportActionsContainer>
  );
};

export const StyledListItemText = styled(ListItemText)({
  textAlign: "right",
  minWidth: "10rem"
});
export const SubListItemText = styled(ListItemText)({
  paddingRight: "30px"
});
export const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: "30px"
});

export const StyledListItemButton = styled(ListItemButton)(
  ({ theme, active, paddingRight }: { theme?: ThemeObjType; active?: boolean; paddingRight?: number }) => ({
    borderBottom: `solid 2px ${theme?.palette.disabled.light}`,
    // padding: '12px 24px',
    padding: "6px 24px",
    paddingRight: paddingRight || 12,
    // backgroundColor: active ? '#EBF0FF52' : 'none',
    "&.Mui-selected": {
      backgroundColor: theme?.palette.primary.main,
      color: "#fff"
    },
    "&.Mui-selected:hover": {
      backgroundColor: theme?.palette.primary.main
    }
  })
);

export const SubItem = styled("div")(
  ({ theme, gray, paddingRight }: { theme?: ThemeObjType; gray?: boolean; paddingRight?: number }) => ({
    display: "flex",
    alignItems: "center",
    padding: "6px 24px",
    paddingRight: paddingRight || 12,
    border: `1px solid ${theme?.palette.disabled.light}`,
    backgroundColor: gray ? "#F0F2F8" : "inherit"
  })
);
export const StyledList = styled(List)({
  marginBottom: "10px",
  paddingBottom: 0,
});
